module.exports = __webpack_public_path__ + "static/media/the-paragon-hotel.7079552c.jpg";